"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfCapabilityService = void 0;
const shared_1 = require("../../shared");
const CapabilityUpdateStatusEvaluator_1 = require("./CapabilityUpdateStatusEvaluator");
const PollingWrapper_1 = require("./PollingWrapper");
class VcfCapabilityService {
    constructor(vcfCapabilityClient, loggingFacade) {
        this.vcfCapabilityClient = vcfCapabilityClient;
        this.loggingFacade = loggingFacade;
    }
    async getUserVehicleCapabilities(vin, devicePlatform) {
        var _a;
        const isWCar = devicePlatform === shared_1.DevicePlatform.WCAR;
        const vcfResponse = await this.vcfCapabilityClient.getUserVehicleCapabilities(vin, isWCar);
        return (_a = vcfResponse.data) !== null && _a !== void 0 ? _a : [];
    }
    isCapabilityAvailable(id, capabilities) {
        return capabilities === null || capabilities === void 0 ? void 0 : capabilities.some(capability => capability.id === id);
    }
    isCapabilityEnabled(id, capabilities) {
        return capabilities === null || capabilities === void 0 ? void 0 : capabilities.some(capability => capability.id === id && capability.status.length === 0);
    }
    isAtLeastOneCapabilityEnabled(ids, capabilities) {
        return capabilities === null || capabilities === void 0 ? void 0 : capabilities.some(capability => (ids.includes(capability.id)
            && capability.status.length === 0));
    }
    isCapabilityDisabledByUser(id, capabilities) {
        const foundCapability = capabilities === null || capabilities === void 0 ? void 0 : capabilities.find(capability => capability.id === id);
        if (!foundCapability) {
            return false;
        }
        const allowedStatusCodes = [1004, 1005, 1014, 3005, 1018, 1013];
        const statusCodes = foundCapability.status;
        if (statusCodes.filter(code => !allowedStatusCodes.includes(code)).length !== 0) {
            return false;
        }
        return (statusCodes.includes(1004) || statusCodes.includes(1005));
    }
    isWeConnectLicenseExpired(id, capabilities) {
        const foundCapability = capabilities === null || capabilities === void 0 ? void 0 : capabilities.find(capability => capability.id === id);
        if (!foundCapability) {
            return false;
        }
        const licenseExpiredCodes = [2001, 2002, 2003];
        const statusCodes = foundCapability.status;
        return statusCodes.filter(code => licenseExpiredCodes.includes(code)).length !== 0;
    }
    isDataSavingMode(id, capabilities) {
        const foundCapability = capabilities === null || capabilities === void 0 ? void 0 : capabilities.find(capability => capability.id === id);
        if (!foundCapability) {
            return false;
        }
        const dataSavingModeCodes = [1021];
        const statusCodes = foundCapability.status;
        return statusCodes.filter(code => dataSavingModeCodes.includes(code)).length !== 0;
    }
    isCapabilityNotAvailable(id, capabilities) {
        const foundCapability = capabilities === null || capabilities === void 0 ? void 0 : capabilities.find(capability => capability.id === id);
        if (!foundCapability) {
            return false;
        }
        const notAvailableCodes = [1008];
        const statusCodes = foundCapability.status;
        if (statusCodes.filter(code => notAvailableCodes.includes(code)).length !== 0) {
            return true;
        }
        return false;
    }
    async updateUserVehicleCapability(vin, devicePlatform, capabilityId, active) {
        var _a;
        const isWCar = devicePlatform === shared_1.DevicePlatform.WCAR;
        const requestIdResponse = await this.vcfCapabilityClient.setUserVehicleCapabilityEnabled(vin, isWCar, capabilityId, active);
        if (!((_a = requestIdResponse === null || requestIdResponse === void 0 ? void 0 : requestIdResponse.data) === null || _a === void 0 ? void 0 : _a.requestID)) {
            this.loggingFacade.error('Could not get requestId to update user vehicle capability');
            throw new shared_1.VcfUpdateCapabilityError();
        }
        const updateStatus = await (0, PollingWrapper_1.poll)(() => this.vcfCapabilityClient.getCapabilityUpdateStatus(vin, isWCar, requestIdResponse.data.requestID), CapabilityUpdateStatusEvaluator_1.evaluate, 1000, 60000);
        this.checkUpdateStatus(updateStatus);
        const capabilities = await this.vcfCapabilityClient.getUserVehicleCapabilities(vin, isWCar);
        if (!(capabilities.data && capabilities.data.length > 0)) {
            this.loggingFacade.error('Could not reload user vehicle capabilities after update');
            throw new shared_1.VcfUpdateCapabilityError();
        }
        return capabilities.data;
    }
    checkUpdateStatus(updateStatus) {
        if (!(updateStatus === null || updateStatus === void 0 ? void 0 : updateStatus.data) || updateStatus.data.status === 'pending') {
            this.loggingFacade.error('Could not update user vehicle capability (timeout)');
            throw new shared_1.TimeoutError();
        }
        if (updateStatus.data.status === 'fail') {
            this.loggingFacade.error('Could not update user vehicle capability (status: fail)');
            throw new shared_1.VcfUpdateCapabilityError();
        }
    }
}
exports.VcfCapabilityService = VcfCapabilityService;
//# sourceMappingURL=VcfCapabilityService.js.map